export class GarageAttachment {
    public id: string;
    public allegato: [];
    public nome: string;
    public note: string;
    public sessionId: string;
    public toDelete: boolean;
    public status: string;

    constructor(
        id?: string,
        allegato?: [],
        nome?: string,
        note?: string,
        sessionId?: string,
        toDelete?: boolean,
        status?: string
      ) {
        this.id = id;
        this.allegato = allegato;
        this.nome = nome;
        this.note = note;
        this.sessionId = sessionId;
        this.toDelete = toDelete;
        this.status = status;
      }
}